import React from 'react';
import { PortfolioRadialGarden } from './PortfolioRadialGarden';
export function Portfolio() {
  return <PortfolioRadialGarden data-id="element-1339" data-mp="26wjkkpmt1d8l" />;
}